<section
  class="software-overrides-section"
  aria-labelledby="software-overrides-title"
>
  <div class="software-overrides-heading">
    <div class="software-overrides-title-group">
      <h1 id="software-overrides-title">
        {{ 'software_override.selection_title' | translate }}
      </h1>
      <div class="line-part"></div>
    </div>
    <span class="software-overrides-count">
      {{
        'software_override.count.components'
          | translate: { count: effectiveSelectionCount }
      }}
    </span>
  </div>

  <app-effective-software-selection
    class="effective-selection-summary"
    [resolutions]="softwareSelectionResolutions"
    [supportedProjectIds]="supportedComponentIds"
    [showHeading]="false"
  ></app-effective-software-selection>
</section>
